import React, { FC } from "react";
import {
  Box,
} from "@mui/material";
import EmailSubscription from "../cards/EmailSubscription/EmailSubscription";
import { ElementDecrator } from "../icons";
import styles from "yet-another-react-lightbox/styles.css";
import ExperiencePromoStyles from "./ExperiencePromoSection.module.scss";

interface ExperiencePromoSectionProps {
 ExperiencePromoSection:{ heading: string;
  description: string;
  buttonText: string;}
  emailSubscriptionData:{
    title: string;
    description: string;
    inputPlaceholder: string;
    buttonText: string;
  }
}

const ExperiencePromoSection: FC<ExperiencePromoSectionProps> = ({ExperiencePromoSection, emailSubscriptionData}) => {
  return (
    <Box
      sx={{ position: "relative", width: "100%", maxWidth: 1328, mx: "auto"  }}
      className="px-4"
    >
      <Box
        component="section"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: { xs: 8, md: "80px" },
          py: 8,
          mb: 2,
        }}
      >
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              width: 176,
              height: 176,
              backgroundColor: "#0f2c59",
              borderRadius: "50%",
              position: "absolute",
              top: -4,
              left: -4,
              zIndex: 0,
            }}
          />
          <Box sx={{ position: "relative", zIndex: 10 }}>
            <Box
              component="img"
              src="/images/img.png" 
              alt="Person with camel in desert"
              sx={{
                width: "100%",
                maxWidth: 555,
                height: "auto",
              }}
            />
          </Box>
        </Box>

      
        <div className="flex flex-col items-center w-full max-w-[516px] gap-[27px]">
          <div className="flex flex-col items-center w-full c-lg:gap-8 gap-6">
            <h3 className="c-lg:text-[40px] text-2xl c-lg:leading-[86px] leading-[48px] text-[#0f2c59] font-bold text-center ">
              {ExperiencePromoSection.heading}
            </h3>
            <p className="text-[20px] leading-[32px] text-[#0f2c59] text-center ">
              {ExperiencePromoSection.description}
            </p>
          </div>

          <button className="h-14 px-[30px] py-[15px] bg-secondary text-primary rounded-[56px] font-medium text-sm  hover:bg-secondary transition-colors duration-200">
            {ExperiencePromoSection.buttonText}
          </button>
        </div>
      </Box>

      <EmailSubscription emailSubscriptionData={emailSubscriptionData} />
      
      <div className={`absolute bottom-[-180px] ltr:right-[-170px] rtl:left-[-170px] ltr:max-c-md:right-[-25px] rtl:max-c-md:left-[-25px]  rtl:rotate-90 max-c-md:!w-[200px] ${ExperiencePromoStyles.elementDecorator}`}>
      <ElementDecrator />
      </div>
    </Box>
  );
};

export default ExperiencePromoSection;
